import React, { useEffect, useState } from 'react';
import WithRouter from '@utils/wrappers/WithRouter';
import * as yup from 'yup';
import TStepper from '@modules/stepper/Stepper';
import MainInformationStepOne from './MainInformationStep1';
import IdentityProviderStepTwo from './IdentityProviderStep2';
import { onlyText, uuidSchema } from '@components/Utils/yup/yup.utils';
import { useAppDispatch } from '@redux/store';
import { onChangeObject } from '@ts/storybook';
import { IRouterProps } from '@interfaces/App.interface';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { COrganization, IConfigStepper } from '@ts/ui-models';
import { Link } from '@components/index';

interface OrganizationStepperProps extends IRouterProps {}

export const configStepper: IConfigStepper = {
  componentId: 'stepperOrganization',
  entity: 'organization',
  fetchURL: '/api/organization/new',
  mainClass: COrganization,
};

const OrganizationStepper: React.FC<OrganizationStepperProps> = props => {
  const crudId = props.transferPropsRoute.params.id;
  const dispatch = useAppDispatch();
  const [organization, setOrganization] = useState<COrganization>(
    COrganization.EmptyOrganization
    /* new COrganization({
      name: 'TestCM',
      logicalId: 'TESTCM',
      acronym: 'TESTCM',
    }) */
  );

  const steps = [
    {
      label: 'Main information',
      icon: 'settings',
      isOptional: false,
      validation: () => organizationStepOneValidation,
      formComponent: MainInformationStepOne,
    },
    {
      label: 'Identity provider',
      icon: 'GroupAdd',
      isOptional: true,
      validation: () => organizationStepTwoValidation,
      formComponent: IdentityProviderStepTwo,
      textInfo: [
        'As part of setting up your new organization, connecting your Microsoft Entra ID is crucial. This connection ensures secure and personalized access, enhancing your experience on our platform.',
        <br key="1" />,
        <br key="1" />,
        <b key="1">Why Connect Your Microsoft Entra ID?</b>,
        <br key="1" />,
        'Linking your Microsoft Entra ID allows for a smoother sign-on experience, easier user management, and stronger security.',
        <br key="1" />,
        <br key="1" />,
        <b key="1">Required Permissions</b>,
        ':',
        <br key="1" />,
        'To integrate seamlessly with our services, the following permissions are needed',
        ':',
        <br key="1" />,
        <li key="1">
          <b key="1">offline_access:</b> Keeps you logged in to avoid frequent sign-ins, ensuring an uninterrupted experience.
        </li>,
        <li key="1">
          <b key="1">openid:</b> Enables authentication, allowing our platform to recognize you through Microsoft Entra ID.
        </li>,
        <li key="1">
          <b key="1">User.Read:</b> Lets our application read your profile information to personalize your experience.
        </li>,
        <br key="1" />,
        <b key="1">Contact Your IT Administrator</b>,
        <br key="1" />,
        'To streamline your setup, consider reaching out to your IT administrator. They can ensure that the necessary permissions are granted quickly and correctly, especially if your organization has specific IT policies or requires approval for such permissions. This step can significantly expedite your integration with our platform.',
        <br key="1" />,
        <br key="1" />,
        <b key="1">Privacy and Security</b>,
        <br key="1" />,
        'We prioritize your privacy and security, using the requested permissions solely to enhance your user experience and maintain security.',
        <br key="1" />,
        <br key="1" />,
        <b key="1">Need Assistance?</b>,
        <br key="1" />,
        'Our support team is ready to assist you with any questions or help you might need during the setup process. Contact us at ',
        <Link key="1" href="https://support.rfiddiscovery.com/" target="_blank" label="here" />,
        '.',
      ],
    },
  ];

  //#region Handlers

  //const onChange = (attr: string) => (e, v) => setOrganization({ ...organization, [attr]: v });
  const onChange = (attr: string) => (e, v) => {
    onChangeObject(setOrganization, attr, v);
  };

  //#endregion

  //#region Functions
  const organizationStepOneValidation = yup.object().shape({
    name: yup.string().required().label('Name'),
    logicalId: yup.string().required().label('ID'),
    acronym: onlyText.required().max(7).label('Acronym'),
  });

  const organizationStepTwoValidation = yup.object().shape({
    identityProviderId: yup.string().label('Identity Provider ID'),
    tenantId: uuidSchema.label('Tenant ID'),
  });

  /* const onSubmitAfterFullValidation = async () => {
    return await postOrganization(dispatch, organization);
  }; */

  const fetchOrganization = async () => {
    if (crudId) {
      const organization = (await dispatch(fetchData({ url: `/api/organization/${crudId}` }))).payload.data;
      setOrganization(organization);
    }
  };
  //#endregion

  useEffect(() => {
    fetchOrganization();
  }, []);

  // console.log(configStepper);
  // console.log(props.mode);
  // console.log(steps);
  // console.log(organization);
  // console.log(onChange);

  return (
    <TStepper
      configStepper={configStepper}
      mode={props.mode}
      steps={steps}
      formData={organization}
      setFormData={onChange}
      //onSubmit={onSubmitAfterFullValidation}
    />
  );
};
export default WithRouter(OrganizationStepper);
